export const SUBMIT_FEEDBACK_REQUEST = "SUBMIT_FEEDBACK_REQUESTT";
export const SUBMIT_FEEDBACK_SUCCESS = "SUBMIT_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDBACK_FAILED = "SUBMIT_FEEDBACK_FAILED";
export const RESET_FEEDBACK_STATE = "RESET_FEEDBACK_STATE";
